import Divider from './Divider';
export type { DividerProps } from './Divider.types';

export default Divider;
